import { useState, useCallback, useEffect } from "react";

import { safeJsonParse } from "../../Shared/utils/commonutils";
import { GEOLOCATION_NOT_SUPPORTED } from "../../Shared/helper/constants";
import { CURRENT_ADD_KEY, COUNTRY_TEXT, LOCALITY_TEXT, OK_TEXT } from "../../FTTX/GlobalConstant";
import { fetchSessionData, removeSessionItem, setSessionData } from "../../Shared/helper/storage";

export function useCurrentLocation() {

  const [location, setLocation] = useState(() => {
    const saved = fetchSessionData("location");
    return saved ? safeJsonParse(saved) : null;
  });
  const [currentAdd, setCurrentAdd] = useState(() => {

    const saved = fetchSessionData(CURRENT_ADD_KEY);
    return saved ? safeJsonParse(saved) : null;
  });

  const [loading, setLoading] = useState(false);
  const [locError, setLocError] = useState(null);

  const requestLocation = useCallback(() => {
    // Already have location
    if (location) {
      !currentAdd && getAddressFromCoords(location?.lat, location?.lng)
      return Promise.resolve(location);
    }

    if (!navigator.geolocation) {
      setLocError(GEOLOCATION_NOT_SUPPORTED);
      return Promise.reject(GEOLOCATION_NOT_SUPPORTED);
    }

    setLoading(true);
    setLocError(null);

    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const locationData = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          setLocation(locationData);
          setSessionData(
            "location",
            locationData
          );

          setLoading(false);
          resolve(locationData);
          getAddressFromCoords(locationData?.lat, locationData?.lng)
        },
        (err) => {
          setLocError(err?.message);
          setLoading(false);
          resolve(err?.message);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    });
  }, [location]);

  useEffect(() => {
    requestLocation();
  }, [requestLocation]);

  const getAddressFromCoords = (lat, lng) => {
    if (!window.google) return;
    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === OK_TEXT && results[0]) {
        const addressComponents = results[0].address_components;
        const formatedAddress = results[0].formatted_address
        let city = "";
        let country = "";

        addressComponents.forEach(component => {
          if (component.types.includes(LOCALITY_TEXT)) {
            city = component.long_name;
          } else if (component.types.includes(COUNTRY_TEXT)) {
            country = component.long_name;
          }
        });
        const address = {
          address: formatedAddress,
          city,
          country,
          lat,
          lng
        }

        setCurrentAdd(address);
        setSessionData(
          CURRENT_ADD_KEY,
          address
        );

      } else {
        setCurrentAdd(null)
      }
    });
  }

  const clearLocation = useCallback(() => {
    removeSessionItem("location");
    setLocation(null);
  }, []);

  const resetError = () => {
    setLocError(null);
  }

  return {
    location,
    loading,
    locError,
    resetError,
    requestLocation,
    clearLocation,
    currentAdd
  };
}